import { CircleMarker, Popup } from "react-leaflet";

import { type BuildingListRow, BuildingStatus } from "../types";

type Props = {
  row: BuildingListRow;
};

export const MapCircleView: React.FC<Props> = ({ row }) => {
  if (!row.lat || !row.lng) return null;

  return (
    <CircleMarker
      key={row.terminalId}
      center={[row.lat, row.lng]}
      radius={7.425}
      pathOptions={{
        color: "#fff",
        weight: 2.0625,
        fillColor:
          row.status === BuildingStatus.ON_TRACK ? "#3F9142" : "#C98A1B",
        fillOpacity: 0.95,
      }}
    >
      <Popup>
        <div
          className="min-w-[158px]"
          style={{
            fontFamily: "'DM Sans',system-ui,sans-serif",
          }}
        >
          <div className="text-[13.5px] font-bold text-[#1D1C1C]">
            {row.name}
          </div>
          <div className="mt-2 flex justify-between gap-[18px] text-[12.5px] text-[#3c3838]">
            <span>Recycling rate</span>
            <b>{row.rate.toFixed(row.rate % 1 ? 1 : 0)}%</b>
          </div>
          <div className="flex justify-between gap-[18px] text-[12.5px] text-[#3c3838]">
            <span>Total waste</span>
            <b>
              {row.waste.toLocaleString()} {row.wasteUnit}
            </b>
          </div>
          <div className="flex justify-between gap-[18px] text-[12.5px] text-[#3c3838]">
            <span>Tenants</span>
            <b>{row.tenants}</b>
          </div>
          <div
            className="mt-[7px] text-[12px] font-semibold"
            style={{
              color:
                row.status === BuildingStatus.ON_TRACK ? "#3F9142" : "#C98A1B",
            }}
          >
            {row.status}
          </div>
        </div>
      </Popup>
    </CircleMarker>
  );
};
